class SelectBox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(document).ready(function(){
      if (window.matchMedia('(max-width: 767px)').matches) {
        const trigger = document.querySelector(".js-parentSelectBox");
        const body = document.querySelector(".js-selectBox");
        const tabChangeLink = document.querySelectorAll(".tabChangeLink");
        const selectTitle = document.querySelector(".js-parentSelectBox-txt");
        
        trigger.addEventListener('click', () => {
          body.classList.toggle('is-open')
        });
        
        tabChangeLink.forEach(item => {
          item.addEventListener('click', () => {
            const title = document.createElement('p');
            const text = item.dataset.name;
            title.textContent = text;
            selectTitle.textContent = text;
          });
        });
      }
    });
  }
}